import { cn } from "@/utils/cn";
import { ComponentPropsWithoutRef, forwardRef } from "react";

interface IconButtonProps extends ComponentPropsWithoutRef<"button"> {
  className?: string;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>((
  { children, className, ...props },
  ref
) => {
  return (
    <button
      ref={ref}
      className={cn(
        "p-1.5 rounded-sm hover:bg-i-white/20 transition-colors focus:outline-none",
        className
      )}
      tabIndex={-1}
      {...props}
    >
      {children}
    </button>
  );
});

IconButton.displayName = "IconButton";

export default IconButton;
